import { render } from "./PropsChildComponent.vue?vue&type=template&id=5fe9b70d&scoped=true&ts=true"
import script from "./PropsChildComponent.vue?vue&type=script&lang=ts"
export * from "./PropsChildComponent.vue?vue&type=script&lang=ts"

import "./PropsChildComponent.vue?vue&type=style&index=0&id=5fe9b70d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe9b70d"]])

export default __exports__